import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useGetCurrentUser } from "../queries";
import { LoadingIndicator } from "./components/loadingIndicator";

interface PrivateLayoutProps {
  children: React.ReactNode;
}

const PrivateLayout: React.FC<PrivateLayoutProps> = ({ children }) => {
  // If not authenticated, redirect to the home page
  const {
    data: authStatus,
    isLoading: authLoading,
    isError: authError,
  } = useGetCurrentUser();

  const history = useNavigate();
  useEffect(() => {
    if (!authLoading && (!authStatus?.id || authError)) {
      history("/");
    }
  }, [authLoading, authStatus, authError]);

  // If still loading, show a loading indicator
  if (authLoading) {
    return <LoadingIndicator fullPageHeight={true} />;
  }

  // If authenticated, render the children (protected content)
  return <div className="admin-layout">{children}</div>;
};

export default PrivateLayout;
